import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import appData from './appData'
import settings from './settings'
import library from './library'
import { AIAddOnGetters } from 'bh-mod'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		settings,
		appData,
		library,
	},
	state: {
		loading: false,
		instances: [],
		instance: null,
		hives: [],
		cats: [],
		theApp: {},
		featureStates: {},
		globalSearch: '',
		sidebarSelection: "SMS",
		fileStructure: [],
		uploadDialog: false,
	},
	mutations: {
		SET_FILE_STRUCTURE(state, data) {
			state.fileStructure = data;
		},
		SET_APP(state, data) {
			state.theApp = data;
		},
		SET_FEATURE_STATES(state, data) {
			state.featureStates = data;
		},
		SET_INSTANCE: (state, data) => {
			state.instance = data;
			state.cats = data.activeApps;
		},
		SIDEBAR_SELECTION(state, data) {
			state.sidebarSelection = data;
		},
		UPDATE_GLOBAL_SEARCH(state, data = '') {
			state.globalSearch = data;
		},
		LOAD: (state, bool = !state.loading) => state.loading = bool,
		cancelUpload: (state) => {
			state.uploadDialog = false
		},
		uploadDialog: (state, folders = []) => {
			state.uploadDialog = true
			state.folders = folders
		},
	},
	getters: {
		isCurrentUserOwner: (state) => {
			const userId = state.user?.user?.id;
			return state.instance?.billingOwner?.id === userId
				|| state.instance?.owner?.id === userId;
		},
		...AIAddOnGetters
	}
})
